// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-183c72ab]:root{--q-color-primary:#4f75ff;--q-color-secondary:#20e4ff;--q-color-accent:#de06e2;--q-color-positive:#03b469;--q-color-negative:#d92057;--q-color-info:#ffe600;--q-color-warning:#ff9b04;--q-color-dark:#161820}.c-dashboard__wrap[data-v-183c72ab]{width:100%}", ""]);
// Exports
module.exports = exports;
